import { render, staticRenderFns } from "./PurchaseRejected.vue?vue&type=template&id=15c99c53&scoped=true"
import script from "./PurchaseRejected.vue?vue&type=script&lang=js"
export * from "./PurchaseRejected.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRejected.vue?vue&type=style&index=0&id=15c99c53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c99c53",
  null
  
)

export default component.exports